import { IconButton, IconButtonType } from "@whitespace/whitespace-ui";
import { IWarningConfirmation } from "interfaces/components/IWarningConfirmation";
import React from "react";

import "./WarningConfirmation.scss";
import { Modal } from "react-bootstrap";

export const WarningConfirmation: React.FC<IWarningConfirmation> = ({
  title,
  item,
  children,
  ...props
}) => {
  const className = `warning-confirmation ${props.className || ""}`;
  return (
    <Modal
      {...props}
      centered
      restoreFocus={false}
      className={className}
      aria-labelledby="warning-confirmation-title"
    >
      <Modal.Header closeButton={false}>
        <Modal.Title id="warning-confirmation-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <IconButton
          iconType={IconButtonType.Cancel}
          variant="secondary"
          onClick={props.onHide}
        >
          OK
        </IconButton>
      </Modal.Footer>
    </Modal>
  );
};
